<template>
  <div>
    <kn-jumbotron></kn-jumbotron>
    <b-container fluid class="container1">
      <b-row id="mcRow">
        <kn-sideMenu></kn-sideMenu>
        <main role="main" class="ml-sm-auto pt-3 px-4 mx-auto col-md-9" style="max-width: 100%;">
          <p>
            <router-link :to="getDecadeLink()"><i class="fa-solid fa-arrow-left fa-lg"></i>
               Επιστροφή στη Δεκαετία {{ decade }}
            </router-link>
          </p>
          <h2><span class="Block blue"></span>Ετος {{ year }}</h2>
          <b-row class="mt-4">
            <!-- Loop through the months and create an accordion for each -->
            <b-col v-for="(monthPair, index) in monthPairs" :key="index" cols="12" class="mb-4">
              <b-card no-body class="mb-1">
                <b-card-header header-tag="header" class="p-1" role="tab">
                  <b-btn block href="#" v-b-toggle="'accordion-' + index" variant="info">{{ monthPair.label }}</b-btn>
                </b-card-header>
                <b-collapse :id="'accordion-' + index" accordion="my-accordion" role="tabpanel">
                  <p class="card-text">
                    <b-embed type="iframe" aspect="1by1" class="pb-2 pt-2" :src="getPdfUrl(monthPair.file, year)"
                      allowfullscreen>
                    </b-embed>
                  </p>
                </b-collapse>
              </b-card>
            </b-col>
          </b-row>
        </main>
      </b-row>
    </b-container>
    <kn-footer></kn-footer>
  </div>
</template>

<script>
import fileMappings from "@/assets/data/file-mappings.json";
import jumbotron from './jumbotron.vue';
import sideMenu from './sideMenu.vue';
import footer from './footer.vue'
export default {
  components: {
    "kn-jumbotron": jumbotron,
    "kn-sideMenu": sideMenu,
    "kn-footer": footer
  },
  props: {
    year: {
      type: Number,
      required: true
    }
  },
  computed: {
    monthPairs() {
      const allPairs = [
        { label: 'Ιανουάριος - Φεβρουάριος', file: 'IAN-FEBR' },
        { label: 'Μάρτιος - Απρίλιος', file: 'MART-APRL' },
        { label: 'Μάϊος - Ιούνιος', file: 'MAIOS-IOYN' },
        { label: 'Ιούλιος - Αύγουστος', file: 'IOUL-AYG' },
        { label: 'Σεπτέμβριος - Οκτώβριος', file: 'SEPT-OKT' },
        { label: 'Νοέμβριος - Δεκέμβριος', file: 'NOEM-DEK' }
      ];

      // Show only the first entry for 2025
      if (this.year === 2025) {
        return allPairs.slice(0, 3); // We are at May-Jun, change with every new upload to keep track
      }

      return allPairs;
    },
    // Compute the decade the year belongs to
    decade() {
      return Math.floor(this.year / 10) * 10; // Example: 2007 => 2000
    },
  },
  methods: {
    getPdfUrl(filePrefix, year) {
      // Check if the year has mappings in the JSON file
      if (fileMappings[year] && fileMappings[year][filePrefix]) {
        const fileId = fileMappings[year][filePrefix];
        return `https://drive.google.com/file/d/${fileId}/preview`;
      }

      // Fallback to default web host URL for files not in the JSON
      return `https://www.kimoliaka-nea.gr/efimerides/efimerida_${filePrefix}_${year}.pdf`;
    },
    // Generate the link to the decade page
    getDecadeLink() {
      return `/${this.decade}`; // Routes to the corresponding decade page
    },
  },
};
</script>

<style scoped>
.card-text {
  padding: 10px;
}
</style>


// WEBPACK FOOTER //
// src/components/yearComponent.vue